import React, { memo, useEffect } from 'react';
import _ from 'lodash';
import PropTypes from 'prop-types';
import { reactSelectCustomStyleCms } from 'helper';
import { InputTemplate } from '../components/inputComponents';
import Region from './Region';
import Province from './Province';
import Municipality from './Municipality';
import Barangay from './Barangay';

// const tmp_region_code = '130000000';
// const tmp_province_code = '133900000';
const tmp_region_code = '';
const tmp_province_code = '';

const regionReadOnly = true;
const provinceReadOnly = true;

const AddressGroupComponent = memo(
  ({
    changedValue,
    name,
    region_name,
    province_name,
    municipality_name,
    barangay_name,
    street_name,
    zip_code_name,
    onChange,
    value,
    readOnly,
    // withBarangay,
    // withStreet,
    // withZipCode,
    validatorMessage,
    type,
    isDisabled,
    isDistrict,
    displayActionButton,
  }) => {
    const { region_code, province_code } = value;

    const handleOnchange = (target, data) => {
      if (target === 'region') {
        onChange({
          target: {
            name,
            value: {
              region_code: data,
              province_code: '',
              municipality_code: '',
              barangay_code: '',
              street: _.get(value, 'street'),
              zip_code: _.get(value, 'zip_code'),
            },
          },
        });
      }

      if (target === 'province') {
        onChange({
          target: {
            name,
            value: {
              region_code,
              province_code: data,
              municipality_code: '',
              barangay_code: '',
              street: _.get(value, 'street'),
              zip_code: _.get(value, 'zip_code'),
            },
          },
        });
      }

      if (target === 'municipality') {
        onChange({
          target: {
            name,
            value: {
              region_code,
              province_code,
              municipality_code: data,
              barangay_code: '',
              street: _.get(value, 'street'),
              zip_code: _.get(value, 'zip_code'),
            },
          },
        });
      }

      if (target === 'barangay') {
        onChange({
          target: {
            name,
            value: {
              region_code,
              province_code,
              municipality_code: _.get(value, 'municipality_code'),
              barangay_code: data,
              street: _.get(value, 'street'),
              zip_code: _.get(value, 'zip_code'),
            },
          },
        });
      }

      if (target === 'street') {
        onChange({
          target: {
            name,
            value: {
              region_code,
              province_code,
              municipality_code: _.get(value, 'municipality_code'),
              barangay_code: _.get(value, 'barangay_code'),
              street: data,
              zip_code: _.get(value, 'zip_code'),
            },
          },
        });
      }

      if (target === 'zip_code') {
        onChange({
          target: {
            name,
            value: {
              region_code,
              province_code,
              municipality_code: _.get(value, 'municipality_code'),
              barangay_code: _.get(value, 'barangay_code'),
              street: _.get(value, 'street'),
              zip_code: data,
            },
          },
        });
      }
    };

    const disableSpecificAddress = (data, addressType) => {
      if (typeof data === 'boolean') return data;

      const arrAddress = data.split(/[ ,]+/);
      if (arrAddress.indexOf(addressType) > -1) return true;

      return false;
    };

    const districtProvineLabel = (data) => {
      if (typeof data === 'boolean') {
        if (!data) return 'Province';

        return 'District';
      }

      if (typeof data === 'string') return data;

      return false;
    };

    const onChangeRegion = (data) => {
      handleOnchange(
        'region',
        data ? _.get(data, 'fullInfo.attributes.code') : ''
      );
    };

    const onChangeProvince = (data) => {
      handleOnchange(
        'province',
        data ? _.get(data, 'fullInfo.attributes.code') : ''
      );
    };

    const onChangeMunicipality = (data) => {
      handleOnchange(
        'municipality',
        data ? _.get(data, 'fullInfo.attributes.code') : ''
      );
    };

    const onChangeBarangay = (data) => {
      handleOnchange(
        'barangay',
        data ? _.get(data, 'fullInfo.attributes.code') : ''
      );
    };

    const onChangeStreet = (e) => {
      handleOnchange('street', e.target.value);
    };

    const onChangeZipCode = (e) => {
      handleOnchange('zip_code', e.target.value);
    };

    useEffect(() => {
      onChange({
        target: {
          name,
          value: {
            region_code: _.get(value, 'region_code') || tmp_region_code,
            province_code: _.get(value, 'province_code') || tmp_province_code,
            municipality_code: _.get(value, 'municipality_code') || '',
            barangay_code: _.get(value, 'barangay_code') || '',
            street: _.get(value, 'street') || '',
            zip_code: _.get(value, 'zip_code') || '',
          },
        },
      });
    }, []);

    const renderActionButtonProps = (item) => {
      if (item)
        return {
          actionButtonContainerClass: 'border',
          withActionButton: () => item,
        };
      return {};
    };

    const selectAdditionalStyle = {
      border: 'none',
    };
    return (
      <>
        <div className="full-group-v2 w-100">
          <div className="form-row">
            <InputTemplate
              title="Region"
              htmlFor="region"
              containerClassName="col-sm-12 col-md-6 col-lg-4"
              formValidatorMsg={validatorMessage(region_name)}
              // Select component props
              withCustomInputComponent={() => (
                <Region
                  name={name}
                  readOnly={type === 'Business' ? regionReadOnly : readOnly}
                  styles={
                    displayActionButton.municipality_code
                      ? reactSelectCustomStyleCms('', selectAdditionalStyle)
                      : reactSelectCustomStyleCms()
                  }
                  value={region_code}
                  onChange={onChangeRegion}
                  // isDisabled={isDisabled}
                  isDisabled={disableSpecificAddress(isDisabled, 'region_code')}
                />
              )}
              // action button (undo)
              {...renderActionButtonProps(displayActionButton.region_code)}
            />

            <InputTemplate
              badge={_.get(changedValue, 'province_code') ? 'changed' : false}
              // title={`${isDistrict ? 'District' : 'Province'}`}
              title={districtProvineLabel(isDistrict)}
              htmlFor="province"
              containerClassName="col-sm-12 col-md-6 col-lg-4"
              formValidatorMsg={validatorMessage(province_name)}
              // Select component props
              withCustomInputComponent={() => (
                <Province
                  name={name}
                  readOnly={type === 'Business' ? provinceReadOnly : readOnly}
                  styles={
                    displayActionButton.municipality_code
                      ? reactSelectCustomStyleCms('', selectAdditionalStyle)
                      : reactSelectCustomStyleCms()
                  }
                  value={province_code}
                  regionCode={region_code}
                  onChange={onChangeProvince}
                  // isDisabled={isDisabled}
                  isDisabled={disableSpecificAddress(
                    isDisabled,
                    'province_code'
                  )}
                />
              )}
              // action button (undo)
              {...renderActionButtonProps(displayActionButton.province_code)}
            />
            <InputTemplate
              badge={
                _.get(changedValue, 'municipality_code') ? 'changed' : false
              }
              title="Municipality/ District"
              htmlFor="municipality"
              containerClassName="col-sm-12 col-md-6 col-lg-4"
              formValidatorMsg={validatorMessage(municipality_name)}
              // Select component props
              withCustomInputComponent={() => (
                <Municipality
                  name={name}
                  readOnly={readOnly}
                  styles={
                    displayActionButton.municipality_code
                      ? reactSelectCustomStyleCms('', selectAdditionalStyle)
                      : reactSelectCustomStyleCms()
                  }
                  value={_.get(value, 'municipality_code')}
                  regionCode={region_code}
                  provinceCode={province_code}
                  onChange={onChangeMunicipality}
                  // isDisabled={isDisabled}displayActionButton
                  isDisabled={disableSpecificAddress(
                    isDisabled,
                    'municipality_code'
                  )}
                />
              )}
              // action button (undo)
              {...renderActionButtonProps(
                displayActionButton.municipality_code
              )}
            />
            {barangay_name && (
              <InputTemplate
                badge={
                  _.get(changedValue, 'municipality_code') ||
                  _.get(changedValue, 'barangay_code')
                    ? 'changed'
                    : false
                }
                title="Barangay"
                htmlFor="barangay"
                containerClassName="col-sm-12 col-md-6 col-lg-4"
                formValidatorMsg={validatorMessage(barangay_name)}
                // Select component props
                withCustomInputComponent={() => (
                  <Barangay
                    name={name}
                    readOnly={readOnly}
                    styles={
                      displayActionButton.barangay_code
                        ? reactSelectCustomStyleCms('', selectAdditionalStyle)
                        : reactSelectCustomStyleCms()
                    }
                    value={_.get(value, 'barangay_code')}
                    regionCode={region_code}
                    provinceCode={province_code}
                    municipalityCode={_.get(value, 'municipality_code')}
                    onChange={onChangeBarangay}
                    // isDisabled={isDisabled}
                    isDisabled={disableSpecificAddress(
                      isDisabled,
                      'barangay_code'
                    )}
                  />
                )}
                // action button (undo)
                // {...renderActionButtonProps(displayActionButton.barangay_code || displayActionButton.municipality_code)}
                {...renderActionButtonProps(displayActionButton.barangay_code)}
                // {...renderBrgyActionButtonProps}
              />
            )}
            {street_name && (
              <InputTemplate
                badge={_.get(changedValue, 'street') ? 'changed' : false}
                title="Unit/Room No./Floor, Building Name, House No., Street Name"
                htmlFor="street"
                containerClassName="col-sm-12 col-md-6 col-lg-4"
                formValidatorMsg={validatorMessage(street_name)}
                // Select component props
                placeholder="_"
                readOnly={readOnly}
                type="input"
                onChange={onChangeStreet}
                value={_.get(value, 'street')}
                className={`text-uppercase ${
                  !_.isEmpty(displayActionButton.street)
                    ? 'full-input-2'
                    : 'full-input-v2'
                }`}
                // disabled={isDisabled}
                disabled={disableSpecificAddress(isDisabled, 'street')}
                // action button (undo)
                {...renderActionButtonProps(displayActionButton.street)}
                // actionButtonContainerClass="border"
                // withActionButton={() => displayActionButton.street}
              />
            )}
            {zip_code_name && (
              <InputTemplate
                isInputMask
                badge={_.get(changedValue, 'zip_code') ? 'changed' : false}
                title="ZIP Code"
                htmlFor="street"
                containerClassName="col-sm-12 col-md-6 col-lg-4"
                formValidatorMsg={validatorMessage(zip_code_name)}
                // Select component props
                placeholder="_"
                readOnly={readOnly}
                type="input"
                maskChar=""
                mask="9999"
                onChange={onChangeZipCode}
                value={_.get(value, 'zip_code')}
                className={`text-uppercase ${
                  !_.isEmpty(displayActionButton.zip_code)
                    ? 'full-input-2'
                    : 'full-input-v2'
                }`}
                // disabled={isDisabled}
                disabled={disableSpecificAddress(isDisabled, 'zip_code')}
                // action button (undo)
                {...renderActionButtonProps(displayActionButton.zip_code)}
                // actionButtonContainerClass="border"
                // withActionButton={() => displayActionButton.zip_code}
              />
            )}
          </div>
        </div>
      </>
    );
  }
);

AddressGroupComponent.defaultProps = {
  changedValue: {},
  name: '',
  region_name: '',
  province_name: '',
  municipality_name: '',
  barangay_name: '',
  street_name: '',
  zip_code_name: '',
  readOnly: null,
  // withBarangay: true,
  // withStreet: true,
  // withZipCode: true,
  value: '',
  validatorMessage: () => {},
  type: '',
  isDisabled: false,
  isDistrict: false,
  displayActionButton: {},
};

AddressGroupComponent.propTypes = {
  changedValue: PropTypes.instanceOf(Object),
  name: PropTypes.string,
  region_name: PropTypes.string,
  province_name: PropTypes.string,
  municipality_name: PropTypes.string,
  barangay_name: PropTypes.string,
  street_name: PropTypes.string,
  zip_code_name: PropTypes.string,
  readOnly: PropTypes.bool,
  onChange: PropTypes.instanceOf(Function).isRequired,
  value: PropTypes.exact({
    region_code: PropTypes.string,
    province_code: PropTypes.string,
    municipality_code: PropTypes.string,
    barangay_code: PropTypes.string,
    street: PropTypes.string,
    zip_code: PropTypes.string,
  }),
  // withBarangay: PropTypes.bool,
  // withStreet: PropTypes.bool,
  // withZipCode: PropTypes.bool,
  validatorMessage: PropTypes.instanceOf(Function),
  type: PropTypes.string,
  isDistrict: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  isDisabled: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  displayActionButton: PropTypes.oneOfType([
    PropTypes.instanceOf(Function),
    PropTypes.instanceOf(Object),
  ]),
};

export default AddressGroupComponent;
